<template>
    <div id="udhr_intro_wrapper" class="min-vh-100 d-flex align-items-center">
        <div v-if="items" class="texture bg-lazy" v-lazy:background-image="items[0].value.texture_image.url_resized_large"></div>
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-7 mb-5">
                    <h2 class="h1">{{ $t($parent.iKey('udhr_section', 'udhr_intro', 'headline')) }}</h2>
                    <p>{{ $t($parent.iKey('udhr_section', 'udhr_intro', 'description')) }}</p>
                </div>
                <div class="col-12 col-sm-5">
                    <div v-if="items">
                        <div class="d-flex quote-wrap pl-5">
                            <SVGQuote v-if="$i18n.locale == 'en'" class="icon-quote w-25 align-self-start"></SVGQuote>
                            <SVGQuoteFr v-else class="flip icon-quote w-25 align-self-start"></SVGQuoteFr>
                            <blockquote class="guide-text2 p-4">
                                {{ $t($parent.iKey('udhr_section', introItem, 'image_pull_quote')) }}
                            </blockquote>
                        </div>
                        
                        <figure class="mb-5 mb-lg-0">
                            <img class="img-fluid pr-5" v-if="introItem.value.image" v-lazy="introItem.value.image.url_resized" :alt="$t($parent.iKey('udhr_section', introItem, 'image_desc'))">
                            <figcaption>{{ $t($parent.iKey('udhr_section', introItem, 'image_caption')) }}</figcaption>
                        </figure>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
    import SVGQuote from '@/assets/icons/quote.svg';
    import SVGQuoteFr from '@/assets/icons/quote-fr.svg'

    export default {
        name: 'UdhrIntro',
        components: {
            SVGQuote,
            SVGQuoteFr
        },
        props: [
            'items'
        ],
        computed: {
            introItem(){
                if(this.items[0]){
                    return this.items[0]
                } else {
                    return undefined
                }
            }
        },
        mounted() {
            // var dur = this.windowHeight
            // const scene = this.$scrollmagic.scene({
            //     triggerElement: '#udhr_intro_wrapper',
            //     triggerHook: 0,
            //     duration: dur
            // })
            // this.$scrollmagic.addScene(
            // scene
            //     .setPin('#udhr_intro_wrapper')
            //     //.addIndicators()
            // )
        }
    }
</script>

<style scoped>
#udhr_intro_wrapper{
    position: relative;
}
figure {
    margin-top: -30px;
}
.quote-wrap {
    z-index: 1;
    position: relative;
}
.icon-quote {
    margin-top: 10px;
    margin-right: -10px;
    z-index: 1;
}
blockquote {
    background-color: #8ee8fb;
}
.texture {
    position: absolute;
    top: 0;
    right: 10%;
    background-size: contain;
    height: 50vh;
    width: 40vw;
    background-repeat: no-repeat;
}

</style>